import { useEffect } from 'react';
import { useSetReceptionBuyer } from 'hooks/business/receptionBuyerStat';
import {
  useSetConversationUnreplyCustomer,
  useSetUnreplyCustormerTimeValue,
} from 'hooks/business/conversation';
import { useQuery } from '@tanstack/react-query';
import { queries } from 'services/queries';
import { unstable_batchedUpdates } from 'react-dom';
import { useNetwork } from 'ahooks';

export const useReceptionBuyerStatBootstrap = () => {
  const setReceptionBuyer = useSetReceptionBuyer();
  const setUnreplyCustormerTime = useSetUnreplyCustormerTimeValue();
  const setConversationUnreplyCustomer = useSetConversationUnreplyCustomer();
  const { online } = useNetwork();

  const { data } = useQuery({
    ...queries.bootstraps.receptionStat(-Math.floor(new Date().getTimezoneOffset() / 60)),
    enabled: online,
    refetchInterval: 15 * 1000,
  });

  useEffect(() => {
    if (data) {
      unstable_batchedUpdates(() => {
        setReceptionBuyer(data);
        setUnreplyCustormerTime(data.currentTimeMs);
        setConversationUnreplyCustomer(0);
      });
    }
  }, [data, setReceptionBuyer, setUnreplyCustormerTime, setConversationUnreplyCustomer]);
};
